import React, { useEffect, useState } from "react";
import Image from "../../components/elements/Image";
import siteLogo from "../../assets/images/logo.png"
import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/form/Button";
import BottomSheetModal from "../../components/elements/BottomSheetModal";
import Input from "../../components/form/Input";
import Checkbox from "../../components/form/Checkbox";
import { apiRequest } from "../../util/apiUtils";
import moment from 'moment';
import { toast } from "react-toastify";
import Textarea from "../../components/form/Textarea";

const PaymentSucces = () => {
  const navigate = useNavigate();
  const [openReciept, setOpenReceipt] = useState(false);
  const [consent, setConsent] = useState(true);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [mainString, setMainString] = useState([]);
  const [transactionId, setTransactionId] = useState('');
  const [tableUid,setTableUid] = useState("");

  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get('hash');
    
    // Simulate loading delay
    setTimeout(() => {
      if (!hash) {
        setError(true);
        setLoading(false);
        return;
      }

      try {
        const orderDetails = window.atob(hash);
        const parsedData = orderDetails.split("|");        
        setMainString(parsedData);
        setTransactionId(parsedData[7] || '');
        setTableUid(parsedData[8] || '')
        setLoading(false);
      } catch (err) {
        setError(true);
        setLoading(false);
      }
    }, 800);
  }, []);

  console.log('transactionId',transactionId)

  const storeRating = async () => {
    setLoading(true);
    try {
      const result = await apiRequest("post", `save-rating`, {
        body: {
          transactionId,
          rating,
          comment,
        },
      });
      if (result.status === 200) {
        //const data = result?.data?.data || {};
        setRating(0);
        setComment('');
        toast.success("Thank you for your feedback!");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setLoading(false);
    }
  };

  const validateEmail = (email) => {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
  };

  const handleSendReceipt = async () => {
    setSending(true);
    setEmailError('');
    if (!email.trim()) {
        setError('Please enter your email address');
        return;
    }

    if (!validateEmail(email)) {
        setError('Please enter a valid email address');
        return;
    }
    try {
      const result = await apiRequest("post", `send-receipt`, {
        body: {
          transactionId: transactionId,
          email: email
        },
      });

      if (result.status === 200) {
        setEmailSent(true);
        setTimeout(() => {
          setOpenReceipt(false);
          setEmailSent(false);
        }, 3000);
      } else {
        setEmailError(result.message || 'Failed to send receipt');
      }
    } catch (error) {
      console.error("Error sending receipt:", error);
      setEmailError('Failed to send receipt. Please try again.');
    } finally {
      setSending(false);
    }
  };

  

  // Skeleton Loader Component
  const SkeletonLoader = () => (
    <div className="w-full xls:max-w-sm bg-white rounded-2xl shadow-sm overflow-hidden pb-0 h-screen xls:mx-auto flex flex-col animate-pulse">
      <div className="border-b border-slate-200">
        <div className="flex items-center justify-between py-3 px-4">
          <div className="w-7 h-7 bg-slate-200 rounded-full"></div>
          <div className="w-10 h-10 bg-slate-200 rounded-full"></div>
        </div>
      </div>

      <div className="text-center px-4">
        <div className="flex items-center my-5 justify-center gap-4">
          <div className="w-6 h-6 bg-slate-200 rounded-full"></div>
          <div className="h-6 w-48 bg-slate-200 rounded"></div>
        </div>

        <div className="bg-slate-100 rounded-lg p-7 mb-6 space-y-4">
          <div className="flex justify-between mb-1">
            <div className="h-4 w-20 bg-slate-200 rounded"></div>
            <div className="h-5 w-20 bg-slate-200 rounded-xl"></div>
          </div>
          <div className="flex justify-between mb-1">
            <div className="h-6 w-24 bg-slate-200 rounded"></div>
            <div className="h-6 w-20 bg-slate-200 rounded"></div>
          </div>
          <div className="h-8 w-full bg-slate-200 rounded-lg"></div>
        </div>

        <div className="mb-6 border-y-2 border-slate-100 py-7">
          <div className="h-5 w-56 bg-slate-200 rounded mx-auto mb-5"></div>
          <div className="flex justify-center gap-4 mb-4">
            {[1, 2, 3, 4, 5].map((num) => (
              <div key={num} className="w-12 h-12 bg-slate-200 rounded-full"></div>
            ))}
          </div>
          <div className="flex justify-between px-6">
            <div className="h-4 w-24 bg-slate-200 rounded"></div>
            <div className="h-4 w-24 bg-slate-200 rounded"></div>
          </div>
        </div>

        <div className="mb-6">
          <div className="h-5 w-48 bg-slate-200 rounded mx-auto mb-3"></div>
          <div className="flex justify-center gap-5">
            <div className="w-8 h-8 bg-slate-200 rounded-full"></div>
            <div className="w-8 h-8 bg-slate-200 rounded-full"></div>
          </div>
        </div>

        <div className="border-t border-slate-100 my-5">
          <div className="h-12 w-full bg-slate-200 rounded-[10px]"></div>
        </div>
      </div>
    </div>
  );

  // Error Screen Component
  const ErrorScreen = () => (
    <div className="w-full xls:max-w-sm bg-white rounded-2xl shadow-sm overflow-hidden pb-0 h-screen xls:mx-auto flex flex-col">
      <div className="border-b border-slate-200">
        <div className="flex items-center justify-between py-3 px-4">
          <Button
            buttonFunction={() => navigate("/")}
            buttonClasses="text-teal-600 hover:text-teal-700 font-medium text-sm bg-slate-100 rounded-full w-7 h-7 hover:bg-transparent flex-shrink-0"
            buttonIcon={"fa-regular fa-arrow-left text-sm"}
            buttonIconPosition="left"
          />
          <div className="flex items-center gap-2">
            <Link to={"/"} className="w-10 h-10 overflow-hidden rounded-full">
              <Image src={siteLogo} classes={"object-cover"} />
            </Link>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="fa-solid fa-exclamation-triangle text-red-500 text-3xl"></i>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Payment Information Not Found
          </h2>
          <p className="text-gray-600 mb-6">
            We couldn't find the payment details. The link may be invalid or expired.
          </p>
          <Button
            buttonLabel="Go to Home"
            buttonClasses={"bg-buttonPrimary rounded-[10px] w-full h-12"}
            buttonLabelClasses={"font-Roboto font-semibold text-lg capitalize"}
            buttonFunction={() => navigate("/")}
          />
        </div>
      </div>
    </div>
  );

  // Show skeleton loader while loading
  if (loading) {
    return <SkeletonLoader />;
  }

  // Show error screen if no hash or invalid data
  if (error) {
    return <ErrorScreen />;
  }

  return (
    <>
      <div className="w-full xls:max-w-sm bg-white rounded-2xl shadow-sm overflow-hidden pb-0 h-screen xls:mx-auto flex flex-col">
        <div className="border-b border-slate-200">
          <div className="flex items-center justify-between py-3 px-4">
            <Button
              buttonFunction={() => navigate("/")}
              buttonClasses="text-teal-600 hover:text-teal-700 font-medium text-sm bg-slate-100 rounded-full w-7 h-7 hover:bg-transparent flex-shrink-0"
              buttonIcon={"fa-regular fa-arrow-left text-sm"}
              buttonIconPosition="left"
            />
            <div className="flex items-center gap-2">
              <Link to={(tableUid && tableUid !== undefined)?`/bistro/home/table/${tableUid}`:`/bistro/home`} className="w-10 h-10 overflow-hidden rounded-full">
                <Image src={siteLogo} classes={"object-cover"} />
              </Link>
            </div>
          </div>
        </div>
      
        <div className="text-center">
          <div className="px-4">
            <div className="flex items-center my-5 justify-center gap-4">
              <span className="text-green-600 text-xl">
                <i className="fa-solid fa-badge-check"></i>
              </span>
              <h2 className="text-lg font-semibold text-[#232222]">
                Payment was successful
              </h2>
            </div>

            <div className="bg-green-100 rounded-lg p-7 mb-6 text-left space-y-4">
              <div className="flex justify-between mb-1">
                <span className="text-sm text-gray-400">
                  Table: {(mainString && mainString.length > 0) ? mainString[4] : ''}
                </span>
                <span className="text-xs font-semibold text-white bg-green-600 px-2 py-0.5 rounded-xl">
                  {mainString && mainString.length > 0 
                    ? mainString[0].charAt(0).toUpperCase() + mainString[0].slice(1) + ' Paid' 
                    : ''}                 
                </span>
              </div>
              <div className="flex justify-between mb-1 items-center">
                <span className="text-lg text-black font-medium">You paid</span>
                <span className="font-medium text-black text-lg">
                  ${(mainString && mainString.length > 0) ? mainString[5] : '0.00'}
                </span>
              </div>
              <div className="bg-white text-black text-sm rounded-lg px-3 py-1 w-full text-center font-medium">
                Paid on {moment((mainString && mainString.length > 0) ? mainString[6] : '').format('h:mm A, MMM DD, YYYY')}
              </div>
            </div>
          </div>


          <div className="mb-6 border-y-2 border-slate-100 py-7">
            <div className="px-4">
              <h3 className="text-sm font-medium text-black mb-5">
                How's your overall experience?
              </h3>

              <div className="flex justify-center gap-4 mb-2">
                {[1, 2, 3, 4, 5].map((num) => (
                  <Button
                    key={num}
                    buttonFunction={() => setRating(num)}  // Update rating on click
                    buttonIcon="fa-solid fa-star text-4xl"
                    buttonIconPosition="left"
                    buttonLabel={num}
                    buttonClasses={`
                      relative w-12 h-12 flex items-center justify-center rounded-full border-none
                      bg-transparent shadow-none focus:outline-none hover:bg-transparent px-0
                      ${num <= rating ? "text-yellow-400" : "text-gray-200"}
                    `}
                    buttonLabelClasses={`
                      absolute inset-0 flex items-center justify-center text-[13px] font-medium
                      ${num <= rating ? "text-black" : "text-gray-600"}
                    `}
                  />
                ))}
              </div>              

              <div className="flex justify-end px-6 mb-2">
              {
                rating === 1  ? ( 
                  <span className="text-rose-600 text-sm font-medium">Not Unsatisfied</span>
                ) : rating === 2 ? (
                  <span className="text-rose-400 text-sm font-medium">Unsatisfied</span> 
                ) : rating === 3 ? (  
                  <span className="text-yellow-500 text-sm font-medium">Neutral</span>
                ) : rating === 4 ? (
                  <span className="text-teal-400 text-sm font-medium">Satisfied</span>
                ) : rating === 5 ? (
                  <span className="text-teal-600 text-sm font-medium">Very Satisfied</span>
                ) : (
                  <span className="text-gray-500 text-sm font-medium">Select a rating</span>
                )
              } 
                {/* <span className="text-rose-600 text-sm font-medium">Not Satisfied</span>
                <span className="text-teal-600 text-sm font-medium">Very Satisfied</span> */}
              </div>
              <div className="flex justify-center gap-4 mb-2">
                <Textarea
                  inputPlaceholder="Share your feedback..."
                  inputClasses="h-24 !text-sm"  
                  inputValue={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>

              {/* Store Rating Button (Trigger API call) */}
              <div className="mt-4">
                <Button
                  buttonLabel={loading ? "Saving..." : "Submit Rating"}
                  buttonFunction={storeRating}
                  isDisable={loading || rating === 0}  // Disable button when no rating is selected or while loading
                  buttonLabelClasses={"font-Roboto font-semibold text-lg capitalize"}
                  buttonClasses={`w-full py-2 px-4 text-white rounded-lg ${loading ? "bg-gray-500" : "bg-buttonPrimary"} ${rating === 0 ? "opacity-50" : ""}`}
                />
              </div>
            </div>
          </div>


          <div className="mb-6 px-4">
            <p className="text-sm text-black mb-3 font-medium">Follow us on social media</p>
            <div className="flex justify-center gap-5">
              <Link 
                to={""} 
                target="_blank"
                className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-full hover:bg-gray-100"
              >
                <i className="fab fa-instagram text-gray-600"></i>
              </Link>
              <Link 
                to={""} 
                target="_blank"
                className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-full hover:bg-gray-100"
              >
                <i className="fab fa-facebook-f text-gray-600"></i>
              </Link>
            </div>
          </div>

          <div className="border-t border-slate-100 my-5">
            <div className="px-4">
              <Button
                buttonLabel="Get the receipt"
                buttonClasses={"bg-buttonPrimary rounded-[10px] w-full h-12"}
                buttonLabelClasses={"font-Roboto font-semibold text-lg capitalize"}
                buttonFunction={() => setOpenReceipt(true)}
              />
            </div>
          </div>
        </div>
      </div>
      <BottomSheetModal 
            isOpen={openReciept} 
            onClose={() => setOpenReceipt(false)}
            //bgclass="p-0 xls:max-w-md xls:mx-auto"
            bgclass={"p-0 pb-5 xls:max-w-sm xls:mx-auto"}
        >
          <div className="p-6">
              {!emailSent ? (
                  <>
                      {/* Header */}
                      <div className="text-center mb-6">
                          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                              <i className="fa-solid fa-receipt text-green-600 text-2xl"></i>
                          </div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">
                              Get Your Receipt
                          </h2>
                          <p className="text-gray-600 text-sm">
                              Enter your email to receive a detailed invoice
                          </p>
                      </div>

                      {/* Payment Success Info */}
                      <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 mb-6 border border-green-200">
                          <div className="flex items-center justify-between">
                              <div className="flex items-center gap-3">
                                  <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                                      <i className="fa-solid fa-check text-white text-lg"></i>
                                  </div>
                                  <div>
                                      <p className="text-sm font-semibold text-gray-700">Payment Successful</p>
                                      <p className="text-xs text-gray-600">Transaction completed</p>
                                  </div>
                              </div>
                              <div className="text-right">
                                  <p className="text-2xl font-bold text-green-600">
                                      ${(mainString && mainString.length > 0) ? mainString[5] : '0.00'}
                                  </p>
                              </div>
                          </div>
                      </div>

                      {/* Email Input */}
                      <div className="mb-6">
                          <Input
                              label="Email Address"
                              inputType="email"
                              inputPlaceholder="your.email@example.com"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              inputClasses="h-12 text-base"
                              disabled={loading}
                          />
                      </div>

                      {/* Error Message */}
                      {error && (
                          <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-3 flex items-start gap-2">
                              <i className="fa-solid fa-exclamation-circle text-red-600 text-sm mt-0.5"></i>
                              <p className="text-sm text-red-800">{error}</p>
                          </div>
                      )}

                      {/* Features List */}
                      <div className="bg-gray-50 rounded-lg p-4 mb-6">
                          <p className="text-xs font-semibold text-gray-700 mb-3">
                              Your invoice will include:
                          </p>
                          <div className="space-y-2">
                              <div className="flex items-center gap-2">
                                  <i className="fa-solid fa-check-circle text-green-600 text-xs"></i>
                                  <span className="text-xs text-gray-600">Detailed itemized receipt</span>
                              </div>
                              <div className="flex items-center gap-2">
                                  <i className="fa-solid fa-check-circle text-green-600 text-xs"></i>
                                  <span className="text-xs text-gray-600">Transaction and order details</span>
                              </div>
                              <div className="flex items-center gap-2">
                                  <i className="fa-solid fa-check-circle text-green-600 text-xs"></i>
                                  <span className="text-xs text-gray-600">PDF format for easy printing</span>
                              </div>
                          </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="flex gap-3">
                          <Button
                              buttonLabel="Skip"
                              buttonClasses="flex-1 bg-gray-200 hover:bg-gray-300 rounded-lg h-12"
                              buttonLabelClasses="text-gray-700 font-semibold"
                              buttonFunction={() => setOpenReceipt(false)}
                              disabled={sending}
                          />
                          <Button
                              buttonLabel={sending ? "Sending..." : "Send Receipt"}
                              buttonClasses="flex-1 bg-green-600 hover:bg-green-700 rounded-lg h-12"
                              buttonLabelClasses="text-white font-semibold"
                              buttonFunction={handleSendReceipt}
                              disabled={sending}
                              buttonIcon={sending ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-paper-plane"}
                              buttonIconPosition="left"
                          />
                      </div>

                      <p className="text-xs text-gray-500 text-center mt-4">
                          <i className="fa-solid fa-lock text-green-600 mr-1"></i>
                          Your email is secure and will only be used for this receipt
                      </p>
                  </>
              ) : (
                  /* Success State */
                  <div className="text-center py-8">
                      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce">
                          <i className="fa-solid fa-check text-green-600 text-3xl"></i>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                          Receipt Sent! ✉️
                      </h3>
                      <p className="text-gray-600 mb-1">
                          Check your inbox at
                      </p>
                      <p className="text-green-600 font-semibold mb-4">
                          {email}
                      </p>
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mx-4">
                          <p className="text-xs text-blue-800">
                              <i className="fa-solid fa-info-circle mr-1"></i>
                              Don't see it? Check your spam folder
                          </p>
                      </div>
                  </div>
              )}
          </div>
      </BottomSheetModal>
      {/* <BottomSheetModal 
        isOpen={openReciept} 
        onClose={() => setOpenReceipt(false)} 
        bgclass={"p-0 pb-5 xls:max-w-sm xls:mx-auto"}
      >
        <div className="border-b border-slate-200 mb-3">
          <div className="px-5 mt-4">
            <h2 className="text-lg font-semibold text-[#232222] mb-1">Get the receipt</h2>
          </div>
        </div>

        <div className="px-5 space-y-4">
          <Input
            label={"Email"}
            inputPlaceholder="Your Email Address"
            inputClasses="h-10 font-normal !text-base text-black"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="flex items-center mt-3">
            <Checkbox
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              checkboxLabel="I consent to receive communications from qlub"
              checkboxLableClass="text-sm text-gray-700 font-normal"
              checkboxClass="border-gray-400 rounded-md peer-checked:bg-gray-700 peer-checked:border-gray-700 text-white"
            />
          </div>
          <Button
            buttonClasses={"bg-buttonPrimary rounded-[10px] w-full h-12"}
            buttonLabel={"Submit"}
            buttonLabelClasses={"text-white font-semibold text-lg"}
            buttonFunction={handleSendReceipt}
          />
        </div>
      </BottomSheetModal> */}
    </>
  );
};

export default PaymentSucces;